import React from 'react';
import Desktop from '../../images/desktop.svg'
import './styles.css';

export default function DesktopAnimation(){
    return (
        <div className="desktop">
            <img src={Desktop} alt="Desktop"/>
            <p>HTML</p>
            <p>CSS</p>
            <p>JS</p>
            <p>React</p>
            <div className="loader"/>
        </div>
    )
}

